//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('addExistingDocArc', {
//        templateUrl: 'views/components/views/addExistingDocArc/addExistingDocArc.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'addExistingDocArcService', 'ttGridFactory', function ($stateParams, utilityService, addExistingDocArcService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                gridReady: false,
//                docArcSearchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('docarc_searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadGrid() }
//                ],
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_addexistingdocarc_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await addExistingDocArcService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue,
//                }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3757,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'docarc_searchtext':
//                        vm.model.setting.docarc_searchtext = '';

//                        if (vm.model.setting.docarc_searchtext === '') loadGrid();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region SUBMIT SEARCH FUNCTION

//            vm.submitSearch = function () {
//                loadGrid();
//            }

//            // #endregion SUBMIT SEARCH FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'docarc_searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.docarc_searchtext) !== true) return;

//                        vm.model.setting.docarc_searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.docarc_searchtext, true) !== true) return;

//                        if (vm.model.setting.docarc_searchtext === '') loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadSetting();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
